/**
 * Entity Management Interfaces
 * Framework-agnostic type definitions for entity management
 */

/**
 * Entity model - represents a business entity/location
 */
export interface Entity {
  entity_name: string;
  entity_code: string;
  channel_name: string;
  region_name: string;
  state_name: string;
  cityname: string;
  entity_type: string;
  pincode: string;
  address: string;
}

/**
 * Entity List API Response
 */
export interface EntityListApiResponse {
  status: number;
  data: Entity[];
}

/**
 * Excel Headers API Response
 */
export interface EntityExcelHeadersApiResponse {
  status: number;
  data: Record<string, string>; // Excel header mapping
}

/**
 * Entity Import API Response
 */
export interface EntityImportApiResponse {
  status: number;
  data: {
    message: string;
    total_count: number;
    success_count: number;
    rejected_count: number;
    rejection_reason: RejectedEntity[];
  };
}

/**
 * Rejected entity with reason
 */
export interface RejectedEntity {
  entity_code: string;
  reason: string;
}

/**
 * Entity Export API Response (returns download URL)
 */
export interface EntityExportApiResponse {
  status: number;
  data: string; // Download URL
}
